import React from 'react';
import { useToken } from '../contexts/TokenContext';
import Dashboard from '../pages/Dashboard';
import IPTokenDashboard from './IPTokenDashboard';

const DashboardRouter = () => {
  const { hasToken } = useToken();
  
  if (hasToken) {
    // Show token-specific dashboard when a token is selected
    return <IPTokenDashboard />;
  } else {
    // Redirect to token selection if no token
    return <div className="p-8 text-center">
      <p>Please select a token to view the dashboard.</p>
      <a href="/" className="text-purple-600 hover:underline">Go to Token Selection</a>
    </div>;
  }
};

export default DashboardRouter;